import { Flex, useRadioGroup } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { LabelRadio } from './LabelRadio';

export interface RadioOption {
    option: string;
    className: string;
    selectedClassName: string;
}

interface RadioFilterProps {
    groupName: string;
    options: RadioOption[];
    defaultOption: string;
    onRadioChange: (nextValue: string) => void;
    value: string;
}

export const RadioFilter: React.FC<RadioFilterProps> = ({
    groupName,
    options,
    defaultOption,
    onRadioChange,
    value,
}) => {
    const { getRootProps, getRadioProps, setValue } = useRadioGroup({
        name: groupName,
        defaultValue: defaultOption,
        onChange: onRadioChange,
    });

    const group = getRootProps();

    useEffect(() => {
        setValue(value);
    }, [value]);

    return (
        <Flex {...group} className={'radio-filter'}>
            {options.map((item) => (
                <LabelRadio
                    key={item.option}
                    radioProps={getRadioProps({ value: item.option })}
                    data={item}
                />
            ))}
        </Flex>
    );
};
